import {cleanObject} from '../../utils/utilities';
import {events} from '../events';

// Monotonic request counter so the reducer can drop stale responses. The page
// fires an on-load auto-submit (default firm/MMID, no symbol); if the user runs a
// manual search before that settles, the two GETs can resolve out of order and the
// late auto-load would clobber the filtered result. Stamping a sequence lets the
// reducer apply only the latest request's response (latest-wins). See reducer.
let getRequestSeq = 0;

/**
 * Get MM symbol appointments for a firm. mic is derived from the Authorization
 * header by cdm-mw, so it is not sent as a query param.
 */
export const getMmAppointments = (params = {}) => ({
    types: [
        events.MM_APPOINTMENTS_GET,
        events.MM_APPOINTMENTS_SUCCESS,
        events.MM_APPOINTMENTS_ERROR
    ],
    requestSeq: ++getRequestSeq,
    payload: {
        client: 'cdmMw',
        request: {
            url: 'api/mm-appointments',
            params: cleanObject({
                userCrd: params.userCrd,
                mmid: params.mmid,
                mmType: params.mmType,
                symbol: params.symbol,
                offset: params.offset,
                limit: params.limit
            })
        }
    }
});

/**
 * Create MM symbol appointments. crd is supplied once via the userCrd param and
 * mic via the Authorization header, so neither is sent per appointment row.
 * @param {Object} params - Request parameters
 * @param {number} params.userCrd - User CRD number
 * @param {Array<Object>} params.appointments - Array of appointments to create
 * @param {string} params.appointments[].mmid - MMID
 * @param {string} params.appointments[].symbol - Symbol
 * @param {string} params.appointments[].mmType - MM Type code
 */
export const createMmAppointments = ({userCrd, appointments}) => ({
    types: [
        events.MM_APPOINTMENTS_CREATE,
        events.MM_APPOINTMENTS_CREATE_SUCCESS,
        events.MM_APPOINTMENTS_CREATE_ERROR
    ],
    payload: {
        client: 'cdmMw',
        request: {
            method: 'POST',
            url: '/api/mm-appointments',
            params: {userCrd},
            data: appointments
        }
    }
});

/**
 * Delete MM symbol appointments. crd is supplied once via the userCrd param and
 * mic via the Authorization header, so neither is sent per appointment row.
 * @param {Object} params - Request parameters
 * @param {number} params.userCrd - User CRD number
 * @param {Array<Object>} params.appointments - Array of appointments to delete
 * @param {string} params.appointments[].mmid - MMID
 * @param {string} params.appointments[].symbol - Symbol
 * @param {(string|number)} params.appointments[].mmType - MM Type code
 */
export const deleteMmAppointments = ({userCrd, appointments}) => ({
    types: [
        events.MM_APPOINTMENTS_DELETE,
        events.MM_APPOINTMENTS_DELETE_SUCCESS,
        events.MM_APPOINTMENTS_DELETE_ERROR
    ],
    payload: {
        client: 'cdmMw',
        request: {
            method: 'DELETE',
            url: '/api/mm-appointments',
            params: {userCrd},
            data: appointments
        }
    }
});
